import i18next from 'i18next';
import XHR from 'i18next-xhr-backend';
import {initReactI18next} from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';
import * as Logger from "./Logger";

const detectionOptions= {
    cookieDomain: 'etplanner',

}

i18next
    .use(initReactI18next)
    .use(XHR)
    .use(LanguageDetector)
    .init({
        react: {
            useSuspense: false, // TODO enable suspense so it UI gets suspended before resources got loaded
        },
        detection: detectionOptions,
        backend: {
            fallbackLng: 'en',
            "debug": true,

            // for all available options read the backend's repository readme file
            loadPath: 'i18n/{{lng}}.json',
            addPath: 'i18n/add/{{ns}}',
        },
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
    }, (err, r) => {
        if (err) return Logger.log('something went wrong loading translation', err);
    });
// i18next.loadLanguages(["pl", "de"], (err, t) => {
//     if (err) return Logger.log('something went wrong loading language', err);
// });
//
// //Uncomment if you want to hardcode language
// i18next.changeLanguage("de", (err, t) => {
//     if (err) return Logger.log('something went wrong changing translation', err);
//     t('key'); // -> same as i18next.t
// });

export default i18next;
